import { IsNotEmpty, IsPhoneNumber, ValidateIf, Matches } from 'class-validator';
import { FormDataBase } from '@/common/form';

export class RegistrationDetailsFormDataCustomer extends FormDataBase {
    @IsNotEmpty({ message: 'Contact Name is required' })
    name: string = '';

    @IsPhoneNumber('AU', { message: 'Contact Phone Number is not valid' })
    @IsNotEmpty({ message: 'Contact Phone Number is required' })
    phone: string = '';

    email: string = '';

    @ValidateIf((o) => !o.hasNoPba)
    @IsNotEmpty({ message: 'Cloud Sight Tenancy Name is required' })
    @Matches(/^[a-zA-Z0-9&'()\-_ ]*$/, { message: 'Cloud Sight Tenancy Name is invalid'})
    tenantName: string = '';

    hasNoPba: boolean = false;
}
